//
//
//
//
//
//
//
//
//
//
//
//
//
//
import trusted from '~/assets/img/footer/picto-trustedShops.png';
export default {
  name: 'TrustedShops',

  data() {
    return {
      trusted
    };
  }

};